import styled from 'styled-components';

import colors from 'constants/colors';
import { rgba } from 'polished';

interface SessionNavigationProps {
  isPrevious?: boolean;
}

export const SessionNavigationWrapper = styled.div`
  display: flex;
  gap: 12px;
  margin-bottom: 12px;
`;

export const SessionNavigationItemLink = styled.a`
  display: block;
  position: relative;
  flex: 1 1 50%;
  background-color: ${colors.main.disabledBtns};
`;

export const SessionNavigationItemContent = styled.div<SessionNavigationProps>`
  position: relative;
  height: 100%;
  padding: 16px 32px;
  z-index: 1;
  text-align: ${({ isPrevious }) => (isPrevious ? 'left' : 'right')};

  &:before,
  &:after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: -1;
    background-color: ${colors.main.disabledBtns};
    opacity: 0.8;
    transition: opacity 0.3s ease;
  }

  &:after {
    opacity: 0;
    background: linear-gradient(
      35deg,
      ${rgba(colors.main.ruby, 0.5)} 16%,
      ${rgba(colors.main.blue, 0.5)} 64%
    );
  }

  &:hover {
    color: #fff;
    text-shadow: 0 0 4px ${colors.main.grey};

    &:after {
      opacity: 1;
    }

    &:before {
      opacity: 0.6;
    }
  }
`;

export const SessionNavigationItemPicture = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  z-index: 0;
`;
